import React from 'react';
import PropTypes from 'prop-types';
import playSprite from 'assets/icons/play.svg';
import Icon from '../Icon';
import { BigPlayButtonStyled, StyledIconWrap } from './styles/BigPlayButtonStyled';

const BigPlayButton = ({ onClick }) => (
  <BigPlayButtonStyled onClickCapture={onClick}>
    <StyledIconWrap>
      <Icon name={playSprite.id} size={32} />
    </StyledIconWrap>
  </BigPlayButtonStyled>
);

BigPlayButton.propTypes = {
  onClick: PropTypes.func,
};

BigPlayButton.defaultProps = {
  onClick: Function.prototype,
};

export default BigPlayButton;
